import { Reducer } from 'redux'
import * as fromActions from '../actions/externalCoursesEnrolled.action'
import { ExternalCoursesEnrolledState } from '../states/externalCourseEnrolled.state'
import { ExternalCourseEnrolled } from '../../models/externalCoursesEnrolled.model'

export const initialState: ExternalCoursesEnrolledState = {
  list: [],
  total: 0,
  perPage: 0,
  sort: [],
  loading: true,
}

type AdministrationListSuccess = {
  type: typeof fromActions.EXTERNAL_COURSE_ENROLLED_GET_LIST_SUCCESS
  payload: {
    data: ExternalCourseEnrolled[]
    total: number
    perPage: number
    sort: any[]
  }
}

type Loading = {
  type:
    | typeof fromActions.EXTERNAL_COURSE_ENROLLED_LOADING
    | typeof fromActions.EXTERNAL_COURSE_ENROLLED_GET_LIST
  payload: {
    loading: boolean
  }
}

export type ReducerActions = AdministrationListSuccess | Loading

export const reducer: Reducer<ExternalCoursesEnrolledState, ReducerActions> = (
  state: ExternalCoursesEnrolledState = initialState,
  action
): ExternalCoursesEnrolledState => {
  switch (action.type) {
    case fromActions.EXTERNAL_COURSE_ENROLLED_GET_LIST_SUCCESS: {
      const { data, total, perPage, sort } = action.payload
      return {
        ...state,
        list: data,
        total,
        perPage,
        sort,
        loading: false,
      }
    }

    case fromActions.EXTERNAL_COURSE_ENROLLED_GET_LIST:
      return {
        ...state,
        loading: true,
      }
    case fromActions.EXTERNAL_COURSE_ENROLLED_LOADING: {
      const { loading } = action.payload
      return {
        ...state,
        loading,
      }
    }

    default:
      return state
  }
}
